import React, { useState } from "react";
import { C } from "../theme";
import { fmtD, Tag, Kpi, Btn, Inp, Sel, AdBanner } from "../shared";

export const MaintenancePage = ({ maintenance, setMaintenance, immId, residents, prestataires }) => {
  const [modal,  setModal]  = useState(false);
  const [detail, setDetail] = useState(null);
  const [filter, setFilter] = useState("tous");
  const list = maintenance.filter(m => m.immId === immId);
  const filtered = filter === "tous" ? list
    : filter === "urgent" ? list.filter(m => ["urgent","critique"].includes(m.priorite) && m.statut !== "Résolu")
    : list.filter(m => m.statut === filter);
  const immRes = residents.filter(r => r.immId === immId);
  const [form, setForm] = useState({titre:"",cat:"Plomberie",priorite:"normal",desc:"",auteur:""});
  const save = () => {
    setMaintenance(p => [...p, {id:Date.now(), immId, ...form, statut:"En attente", date:new Date().toISOString().slice(0,10), prestataire:null}]);
    setModal(false);
    setForm({titre:"",cat:"Plomberie",priorite:"normal",desc:"",auteur:""});
  };
  const resolve = id => setMaintenance(p => p.map(m => m.id===id ? {...m,statut:"Résolu"} : m));
  const assign  = (id, prest) => setMaintenance(p => p.map(m => m.id===id ? {...m,prestataire:prest,statut:"En cours"} : m));
  const priorityColor = {normal:[C.blue,C.blueL], urgent:[C.gold,"#fffbeb"], critique:[C.red,"#fff1f1"]};
  const statutColor   = {"En attente":[C.gold,"#fffbeb"], "En cours":[C.blue,C.blueL], Résolu:[C.green,"#d1fae5"]};
  const cats = ["Plomberie","Électricité","Ascenseur","Serrurerie","Maçonnerie","Peinture","Jardinage","Autre"];
  const enCours   = list.filter(m => m.statut === "En cours").length;
  const enAttente = list.filter(m => m.statut === "En attente").length;
  const resolus   = list.filter(m => m.statut === "Résolu").length;
  const critiques = list.filter(m => m.priorite === "critique" && m.statut !== "Résolu").length;
  return (
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:22}}>
        <div>
          <h2 style={{fontSize:24,fontWeight:800,color:C.text}}>Maintenance & Incidents</h2>
          <p style={{color:C.muted,fontSize:13}}>{list.length} demandes · Suivi en temps réel</p>
        </div>
        <Btn onClick={() => setModal(true)}>+ Nouvelle demande</Btn>
      </div>
      {critiques > 0 && (
        <div className="fu" style={{background:"linear-gradient(90deg,#b91c1c,#dc2626)",borderRadius:14,padding:"12px 20px",marginBottom:18,display:"flex",alignItems:"center",gap:12}}>
          <span style={{fontSize:20}}>🚨</span>
          <p style={{color:"#fff",fontWeight:600,fontSize:14}}>{critiques} incident(s) critique(s) — intervention immédiate requise</p>
        </div>
      )}
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:14,marginBottom:20}}>
        <Kpi icon="🔴" label="Critiques"  value={critiques}  color={C.red}   delay={0} />
        <Kpi icon="⏳" label="En attente" value={enAttente}  color={C.gold}  delay={60} />
        <Kpi icon="🔄" label="En cours"   value={enCours}    color={C.blue}  delay={120} />
        <Kpi icon="✅" label="Résolus"    value={resolus}    color={C.green} delay={180} />
      </div>
      <AdBanner />
      <div style={{display:"flex",gap:7,marginBottom:16,flexWrap:"wrap"}}>
        {[["tous","Tous",list.length],["urgent","⚠️ Urgents",list.filter(m=>["urgent","critique"].includes(m.priorite)&&m.statut!=="Résolu").length],["En attente","En attente",enAttente],["En cours","En cours",enCours],["Résolu","Résolus",resolus]].map(([k,l,n]) => (
          <button key={k} className="btn" onClick={() => setFilter(k)}
            style={{padding:"5px 13px",borderRadius:20,fontSize:12,fontWeight:600,background:filter===k?C.teal:"#fff",color:filter===k?"#fff":C.muted}}>
            {l} ({n})
          </button>
        ))}
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:14}}>
        {filtered.map((m, i) => {
          const [pc,pb] = priorityColor[m.priorite] || [C.muted,"#f9f9f9"];
          const [sc,sb] = statutColor[m.statut] || [C.muted,"#f9f9f9"];
          return (
            <div key={m.id} className="fu ch" style={{animationDelay:`${i*50}ms`,background:C.card,borderRadius:16,padding:20,
              boxShadow:m.priorite==="critique"?"0 4px 24px rgba(240,77,77,.2)":"0 2px 14px rgba(11,19,51,.06)",
              border:m.priorite==="critique"?`1.5px solid ${C.red}44`:"1.5px solid transparent"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:12}}>
                <div style={{display:"flex",gap:7,flexWrap:"wrap"}}>
                  <span style={{background:pb,color:pc,padding:"3px 10px",borderRadius:20,fontSize:11,fontWeight:700}}>{m.priorite.charAt(0).toUpperCase()+m.priorite.slice(1)}</span>
                  <span style={{background:sb,color:sc,padding:"3px 10px",borderRadius:20,fontSize:11,fontWeight:700}}>{m.statut}</span>
                  <span style={{background:C.bg,color:C.muted,padding:"3px 10px",borderRadius:20,fontSize:11,fontWeight:600}}>{m.cat}</span>
                </div>
                <span style={{fontSize:11,color:C.muted}}>{fmtD(m.date)}</span>
              </div>
              <h4 style={{fontSize:14,fontWeight:700,color:C.text,marginBottom:5}}>{m.titre}</h4>
              <p style={{fontSize:12,color:C.muted,marginBottom:10,lineHeight:1.5}}>{m.desc}</p>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <div style={{display:"flex",alignItems:"center",gap:6}}>
                  <span style={{fontSize:12}}>👤</span>
                  <span style={{fontSize:12,color:C.muted}}>{m.auteur || "—"}</span>
                  {m.prestataire && <span style={{fontSize:12,color:C.blue,fontWeight:600}}> · 🔧 {m.prestataire}</span>}
                </div>
                <div style={{display:"flex",gap:6}}>
                  {m.statut !== "Résolu" && (
                    <button className="btn" onClick={() => setDetail(m)}
                      style={{padding:"4px 10px",background:C.tealL,color:C.teal,borderRadius:8,fontWeight:600,fontSize:11}}>Gérer</button>
                  )}
                  {m.statut === "Résolu" && <span style={{fontSize:11,color:C.green,fontWeight:600}}>✓ Résolu</span>}
                </div>
              </div>
            </div>
          );
        })}
      </div>
      {detail && (
        <div className="ov" onClick={() => setDetail(null)}>
          <div className="mb" style={{width:560}} onClick={e => e.stopPropagation()}>
            <h3 style={{fontSize:17,fontWeight:800,color:C.text,marginBottom:18}}>{detail.titre}</h3>
            <p style={{fontSize:13,color:C.muted,marginBottom:18,padding:"12px 14px",background:C.bg,borderRadius:10,lineHeight:1.6}}>{detail.desc}</p>
            {[["Catégorie",detail.cat],["Signalé par",detail.auteur||"—"],["Date",fmtD(detail.date)],["Statut",detail.statut]].map(([l,v]) => (
              <div key={l} style={{display:"flex",justifyContent:"space-between",padding:"8px 0",borderBottom:`1px solid ${C.border}`,fontSize:13}}>
                <span style={{color:C.muted}}>{l}</span><span style={{fontWeight:600,color:C.text}}>{v}</span>
              </div>
            ))}
            <div style={{marginTop:16}}>
              <p style={{fontSize:11,fontWeight:700,color:C.muted,textTransform:"uppercase",marginBottom:8}}>Assigner un prestataire</p>
              <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:14}}>
                {prestataires.slice(0,4).map(p => (
                  <button key={p.id} className="btn" onClick={() => { assign(detail.id, p.nom); setDetail(null); }}
                    style={{padding:"6px 12px",borderRadius:9,background:C.blueL,color:C.blue,fontWeight:600,fontSize:12}}>🔧 {p.nom}</button>
                ))}
              </div>
            </div>
            <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
              <Btn onClick={() => setDetail(null)} outline>Fermer</Btn>
              <Btn onClick={() => { resolve(detail.id); setDetail(null); }} color={C.green}>✓ Marquer résolu</Btn>
            </div>
          </div>
        </div>
      )}
      {modal && (
        <div className="ov" onClick={() => setModal(false)}>
          <div className="mb" onClick={e => e.stopPropagation()}>
            <h3 style={{fontSize:19,fontWeight:800,color:C.text,marginBottom:20}}>Nouvelle demande de maintenance</h3>
            <Inp label="Titre" value={form.titre} onChange={v => setForm({...form,titre:v})} placeholder="Ex: Fuite d eau hall A" />
            <Sel label="Catégorie" value={form.cat} onChange={v => setForm({...form,cat:v})} options={cats} />
            <Sel label="Priorité" value={form.priorite} onChange={v => setForm({...form,priorite:v})} options={[{v:"normal",l:"Normal"},{v:"urgent",l:"Urgent"},{v:"critique",l:"Critique"}]} />
            <div style={{marginBottom:14}}>
              <label style={{display:"block",fontSize:11,fontWeight:700,color:C.muted,marginBottom:5,textTransform:"uppercase"}}>Signalé par</label>
              <select value={form.auteur} onChange={e => setForm({...form,auteur:e.target.value})}
                style={{width:"100%",padding:"10px 14px",borderRadius:10,border:`1.5px solid ${C.border}`,fontSize:14,fontFamily:"DM Sans",background:"#fff"}}>
                <option value="">— Copropriétaire —</option>
                {immRes.map(r => <option key={r.id} value={`${r.prenom} ${r.nom}`}>{r.prenom} {r.nom} ({r.apt})</option>)}
              </select>
            </div>
            <div style={{marginBottom:14}}>
              <label style={{display:"block",fontSize:11,fontWeight:700,color:C.muted,marginBottom:5,textTransform:"uppercase"}}>Description</label>
              <textarea className="inp" rows={3} value={form.desc} onChange={e => setForm({...form,desc:e.target.value})}
                style={{width:"100%",padding:"10px 14px",borderRadius:10,border:`1.5px solid ${C.border}`,fontSize:14,color:C.text,resize:"vertical"}} />
            </div>
            <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
              <Btn onClick={() => setModal(false)} outline>Annuler</Btn>
              <Btn onClick={save}>Créer</Btn>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

/* ══════════════════════════════════════
   SYNDIC — EMPLOYÉS
══════════════════════════════════════ */
